var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownload02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24198_2044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6867 10.423L16.6776 5.67306C16.6749 4.27293 16.6735 3.57286 16.4 3.03861C16.1594 2.56867 15.7762 2.18695 15.3054 1.94817C14.7701 1.67672 14.07 1.67807 12.6699 1.68076L7.33654 1.69103C5.93641 1.69373 5.23635 1.69507 4.70209 1.96859C4.23215 2.20917 3.85044 2.59236 3.61166 3.06323C3.34021 3.59853 3.34155 4.29859 3.34425 5.69872L3.36093 14.3654C3.36363 15.7655 3.36497 16.4656 3.63849 16.9998C3.87908 17.4698 4.26226 17.8515 4.73313 18.0903C5.26843 18.3617 5.96846 18.3604 7.36851 18.3577L10.452 18.3517M11.6843 9.18267L6.68431 9.1923M8.35739 12.5224L6.69073 12.5256M13.3446 5.84614L6.6779 5.85897M12.5305 15.8477L15.0353 18.3429M15.0353 18.3429L17.5305 15.8381M15.0353 18.3429L15.0257 13.3429",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24198_2044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.0385742) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload02);
export default __webpack_public_path__ + "static/media/file-download-02.bf97236d65decf91461cf9f015a640bd.svg";
export { ForwardRef as ReactComponent };